import ErrorBoundary from "../ErrorBoundary";
import React from 'react';
import BaseSubGridPanel from "../Base/BaseSubGridPanel";

const keyName = `BankPropsSub`;

export default class BankPropsSub extends BaseSubGridPanel {

    constructor(props) {
        super(props);
        if (window.IasConfig.devMode) console.debug(`${keyName} constructor`, props);
        const context = this;
        context.gridName=`BankPropsSubGrid`;
    }

    //заголовок окна
    setDialogTitle(context) {
        context.dialog.cmp.setTitle(`Банковские реквизиты охотпользователя ${context.grid.getCurrentRow()[`user_name`]}`);
    }

}

